import { Box, Card, CardContent, Skeleton } from "@mui/material";
import { useRole } from "@/hooks/userRole";
import Dashboard from "./Dashboard";
import AdminHome from "./AdminHome";

const HomeSkeleton = () => (
  <Box sx={{ p: { xs: 2, md: 4 } }}>
    <Card>
      <CardContent>
        <Skeleton variant="text" width="42%" height={64} />
        <Skeleton variant="text" width="68%" />
        <Skeleton
          variant="rectangular"
          height={180}
          sx={{ mt: 3, borderRadius: 2 }}
        />
      </CardContent>
    </Card>
  </Box>
);

/**
 * Page racine React-Admin.
 *
 * L'Accueil est volontairement limité à l'admin. Les autres rôles retrouvent
 * exactement leur dashboard historique sur `/`, ce qui évite toute régression
 * de navigation ou de chargement de données.
 */
const Home = () => {
  const { role, loading } = useRole();

  if (loading) {
    return <HomeSkeleton />;
  }

  if (role === "admin") {
    return <AdminHome />;
  }

  return <Dashboard />;
};

export default Home;
